import { createScreenViewIds } from "@sa-nu/event-log";
import { v4 as uuidv4 } from "uuid";

/**
 * ログの `screenSessionId` とイベントログの `screen_view_id` を同じ値にするための
 * 唯一のインスタンス。LogProvider と AnalyticsProvider の effect の順序に依存しない。
 */
export const screenViewIds = createScreenViewIds(uuidv4);

/** 画面表示の鍵。パスか query が変わったら別の表示として数える */
export function screenViewKey(pathname: string, query: string): string {
  return query ? `${pathname}?${query}` : pathname;
}
